import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';

export function addCreatorsToListMessage(listName: string) {
  return (
    <span className="ml-1">
      Click
      {' '}
      <BookmarkAddOutlinedIcon />
      {' '}
      to add a creator to your
      {' '}
      <strong>
        {listName}
      </strong>
      {' '}
      list
    </span>
  );
}
